(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79],{

/***/ 63597:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suport-clienti/[categoryUrlKey]",
      function () {
        return __webpack_require__(12949);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _categoryUrlKey_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./components/withRouterPageLayout.js
var withRouterPageLayout = __webpack_require__(61167);
// EXTERNAL MODULE: ./store/support/actions.js
var actions = __webpack_require__(3697);
// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./containers/Support/Layout.js + 1 modules
var Layout = __webpack_require__(72998);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./containers/Support/ArticleCard.js + 1 modules
var ArticleCard = __webpack_require__(34611);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./containers/Support/RelatedArticles.js





function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var RelatedArticles = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(RelatedArticles, Component1);
    var _super = _createSuper(RelatedArticles);
    function RelatedArticles() {
        _classCallCheck(this, RelatedArticles);
        return _super.apply(this, arguments);
    }
    _createClass(RelatedArticles, [
        {
            key: "render",
            value: function render() {
                var items = this.props.items;
                if (!items || !items.length) {
                    return null;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-gray-lighter rounded px-5 pt-4 pb-5 rounded-tr-lg rounded-bl-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            title: "Te-ar mai putea interesa",
                            as: "h2",
                            display: "h2",
                            classesProp: "-tracking-0.5 text-2xl leading-31.2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "m-0 mt-3 p-0",
                            children: items && items.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    className: "mt-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "".concat(settings.baseUrl, "/suport-clienti/").concat(item.slug, "/"),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "inline-block text-sm leading-24 text-red-brand -tracking-0.29",
                                            children: "".concat(item.name)
                                        })
                                    })
                                }, item.slug);
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return RelatedArticles;
}(react.Component);
/* harmony default export */ var Support_RelatedArticles = (RelatedArticles);

;// CONCATENATED MODULE: ./pages/suport-clienti/[categoryUrlKey]/index.js













function _categoryUrlKey_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _categoryUrlKey_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _categoryUrlKey_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _categoryUrlKey_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _categoryUrlKey_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _categoryUrlKey_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _categoryUrlKey_getPrototypeOf(o) {
    _categoryUrlKey_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _categoryUrlKey_getPrototypeOf(o);
}
function _categoryUrlKey_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _categoryUrlKey_setPrototypeOf(subClass, superClass);
}
function _categoryUrlKey_possibleConstructorReturn(self, call) {
    if (call && (_categoryUrlKey_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _categoryUrlKey_assertThisInitialized(self);
}
function _categoryUrlKey_setPrototypeOf(o, p) {
    _categoryUrlKey_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _categoryUrlKey_setPrototypeOf(o, p);
}
var _categoryUrlKey_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _categoryUrlKey_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _categoryUrlKey_createSuper(Derived) {
    var hasNativeReflectConstruct = _categoryUrlKey_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _categoryUrlKey_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _categoryUrlKey_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _categoryUrlKey_possibleConstructorReturn(this, result);
    };
}
var SupportCategoryPage = /*#__PURE__*/ function(Component1) {
    "use strict";
    _categoryUrlKey_inherits(SupportCategoryPage, Component1);
    var _super = _categoryUrlKey_createSuper(SupportCategoryPage);
    function SupportCategoryPage() {
        _categoryUrlKey_classCallCheck(this, SupportCategoryPage);
        return _super.apply(this, arguments);
    }
    _categoryUrlKey_createClass(SupportCategoryPage, [
        {
            key: "render",
            /*#__PURE__*/ value: function render() {
                var _props = this.props, supportCategoryName = _props.supportCategoryName, supportCategories = _props.supportCategories, supportArticle = _props.supportArticle, supportParent = _props.supportParent, supportArticleFaqs = _props.supportArticleFaqs, supportArticleRelated = _props.supportArticleRelated;
                if (!supportCategories || !supportArticle) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                        layout: "404"
                    }));
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "".concat(supportParent === null || supportParent === void 0 ? void 0 : supportParent.name, " — ").concat(supportCategoryName)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 2,
                                    name: "Suport clienti",
                                    url_key: "suport-clienti/"
                                },
                                {
                                    id: 1,
                                    level: 99,
                                    name: "".concat(supportParent.name, " — ").concat(supportCategoryName)
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                            categories: supportCategories,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "pb-6 lg:py-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "lg:flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "lg:w-2/3 lg:pr-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-6 lg:pt-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                            title: supportCategoryName,
                                                            as: "h1",
                                                            display: "h1",
                                                            classesProp: "text-left mb-2 mt-4 lg:mt-0"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard/* default */.Z, {
                                                        item: supportArticle,
                                                        articleSlug: supportArticle.slug
                                                    }, supportArticle.slug),
                                                    supportArticleFaqs && !!supportArticleFaqs.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                        className: "mt-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mb-6",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                                    title: "Intrebari frecvente",
                                                                    as: "h2",
                                                                    display: "h2"
                                                                })
                                                            }),
                                                            supportArticleFaqs.map(function(item) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ArticleCard/* default */.Z, {
                                                                    item: item,
                                                                    articleSlug: item.slug
                                                                }, item.slug);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            supportArticleRelated && !!supportArticleRelated.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "lg:w-1/3",
                                                style: {
                                                    minWidth: "305px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_RelatedArticles, {
                                                    items: supportArticleRelated
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return SupportCategoryPage;
}(react.Component);
SupportCategoryPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var reduxStore, query, res, categoryUrlKey, categories, articleRes;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore, query = ctx.query, res = ctx.res;
                    categoryUrlKey = query.categoryUrlKey;
                    categories = reduxStore.getState().support.categories;
                    _ctx.t0 = // Load data
                    !categories;
                    if (!_ctx.t0) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 7;
                    return reduxStore.dispatch((0,actions/* getSupportCategories */.eU)());
                case 7:
                    _ctx.next = 9;
                    return reduxStore.dispatch((0,actions/* getSupportCategoryArticles */.fk)(categoryUrlKey));
                case 9:
                    articleRes = _ctx.sent;
                    if (!articleRes && res) {
                        res.statusCode = 404;
                    }
                    return _ctx.abrupt("return", {
                        categoryUrlKey: categoryUrlKey
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
SupportCategoryPage.pageLayout = "default";
SupportCategoryPage.layoutProps = {
    displaySearch: false
};
/* harmony default export */ var _categoryUrlKey_ = ((0,withRouterPageLayout/* default */.Z)((0,es/* connect */.$j)(function(state) {
    return {
        supportCategoryName: state.support.categoryName,
        supportCategories: state.support.categories,
        supportArticle: state.support.article,
        supportParent: state.support.parent,
        supportArticleFaqs: state.support.articleFaqs,
        supportArticleRelated: state.support.articleRelated
    };
})(SupportCategoryPage)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1223,8768,9774,2888,179], function() { return __webpack_exec__(63597); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);